let videoPlay = {
    init: function () {
        document.querySelectorAll('.js-video-wrapper-inline').forEach((i) => {
            if (i) {
                const observer = new IntersectionObserver((entries) => {
                    videoObserverCallback(entries, observer, i)
                },
                    { threshold: [0, 0.2] }
                    // { rootMargin: "400px 0px" } TODO: we migt need this again?
                    );
                observer.observe(i);
            }
        })

        const videoObserverCallback = (entries, observer, header) => {
            entries.forEach((entry, i) => {
                if (entry.intersectionRatio > 0 || entry.isIntersecting) {
                    const frame = document.createElement("iframe");
                    frame.classList.add("video-frame");
                    frame.setAttribute("src", entry.target.dataset.url);
                    frame.setAttribute("title", entry.target.dataset.title);
                    frame.setAttribute("mozallowfullscreen", "1");
                    frame.setAttribute("webkitallowfullscreen", "1");
                    frame.setAttribute("allow", "autoplay; fullscreen");

                    entry.target.prepend(frame);


                    console.log("mobile", entry.target.dataset.urlMobile)
                    if(entry.target.dataset.urlMobile){
                        const frameMobile = document.createElement("iframe");
                        frameMobile.classList.add("video-frame-mobile");
                        frameMobile.setAttribute("src", entry.target.dataset.urlMobile);
                        frameMobile.setAttribute("title", entry.target.dataset.title);
                        frameMobile.setAttribute("mozallowfullscreen", "1");
                        frameMobile.setAttribute("webkitallowfullscreen", "1");
                        frameMobile.setAttribute("allow", "autoplay; fullscreen");

                        entry.target.prepend(frameMobile);
                    }

                    observer.unobserve(entry.target);
                }
            });
        };

        const playButtons = document.querySelectorAll(".js-video-play-inline");
        playButtons.forEach((btn) => btn.addEventListener("click", triggerVideo));

        function triggerVideo() {
            const container = this.closest(".js-video-player-inline");
            let videoFrame = container.querySelector("iframe");
            videoFrame.src += "&autoplay=1";
            container.classList.add("active");
        }
    }
}

export default videoPlay;